module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/logout-3049c319a0728d67ac015c952ee440e5.svg";